/**
 * main.js
 *
 * Bootstraps Vuetify and other plugins then mounts the App
 */

// Plugins
import { registerPlugins } from '@/plugins'

// Importar override para fontes MDI
import '@/styles/mdi-override.css'

// Global components
import zTextField from '@/components/global/zTextField.vue'
import zTextFieldNumber from '@/components/global/zTextFieldNumber.vue'
import zTextFieldSearch from '@/components/global/zTextFieldSearch.vue'
import zDatePickerMenu from '@/components/global/zDatePickerMenu.vue'
import ProgramacaoLocalizador from '@/components/ProgramacaoLocalizador.vue'

// ApexCharts - Importação dinâmica para melhorar performance
// O componente só será carregado quando necessário
const VueApexCharts = defineAsyncComponent(() => import('vue3-apexcharts'))

// ✅ ADICIONAR VUEDRAGGABLE
import draggable from 'vuedraggable'

// Root component
import App from './App.vue'

// Composables / libs
import { createApp, defineAsyncComponent } from 'vue'
import { createPinia } from 'pinia'

// ✨ NOVO: Plugin de persistência
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

// ✨ NOVO: Import da store de usuário
import { useUserStore } from '@/store/userStore'

// ✨ NOVO: Import da diretiva de permissões
import { permissionDirective } from '@/directives/permission'

const app = createApp(App)

// ✨ Registrar diretiva de permissões globalmente
app.directive('permission', permissionDirective)

// Removido a inicialização duplicada do Pinia aqui
// O Pinia agora é inicializado apenas em store/index.js e usado em plugins/index.js

// Global components
app.component('z-texto', zTextField)
app.component('z-numero', zTextFieldNumber)
app.component('z-locate', zTextFieldSearch)
app.component('z-data', zDatePickerMenu)
app.component('ProgramacaoLocalizador', ProgramacaoLocalizador)

// ✅ REGISTRAR VUEDRAGGABLE GLOBALMENTE
app.component('draggable', draggable)

// Register Vuetify & other plugins
registerPlugins(app)

// Register ApexCharts globally
app.component('apexchart', VueApexCharts)

// Montar a aplicação primeiro
app.mount('#app')

// Depois de montar, podemos inicializar o userStore com segurança
// Adicionado setTimeout para garantir que o Pinia esteja completamente inicializado
setTimeout(() => {
  try {
    const userStore = useUserStore()
    userStore.initializeAuth().then((isAuthenticated) => {
      console.log(' Aplicação inicializada - Autenticado:', isAuthenticated)
    }).catch((error) => {
      console.error(' Erro na inicialização da autenticação:', error)
    })
  } catch (error) {
    console.error(' Erro ao acessar userStore:', error)
  }
}, 100) // Pequeno delay para garantir inicialização completa